<ng-container *ngIf="repliesCount === 0">
  <div class="replies-meta fs-12px">{{ repliesCount | repliesCount }}</div>
  <a class="ui-link ui-small" [uiParams]="{ commentId: commentId }" uiSref="^.comment">{{ "leave_reply" | localize }}</a>
</ng-container>

<ng-container *ngIf="repliesCount > 0">
  <ui-assignee-avatar-group [uiMax]="4" uiSize="xs">
    <ui-assignee-avatar *ngFor="let assigneeId of usersRepliedIds" [fromAssigneeId]="assigneeId" />
  </ui-assignee-avatar-group>
  <a class="ui-link ui-small" [uiParams]="{ commentId: commentId }" uiSref="^.comment">{{ repliesCount | repliesCount }}</a>
  <div class="replies-meta fs-12px" [uiTooltipTitle]="lastReplyAt | lastReplyOn" tooltipIfOverflow="hover" ui-tooltip>{{ lastReplyAt | lastReplyOn }}</div>
</ng-container>
